import CardDefault from "components/Cards/CardDefault/index";
import { Flex } from "@chakra-ui/react";
import { Divider } from "@chakra-ui/react";
import ContentRight from "./ContentRight";
import DescricaoContratoCliente from "./DescricaoContratoCliente";
import ContentTag from "./ContentTag";
import { ClienteContrato } from "core/features/cliente/typings";
import { ModalContrato } from "./ModalContrato/index";
import { useState } from "react";

interface ItemsContratosClienteProps {
  item: ClienteContrato;
}

export default function ItemsContratosCliente({
  item,
}: ItemsContratosClienteProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  return (
    <>
      <CardDefault
        mb={6}
        px={3}
        py={0}
        cursor="pointer"
        onClick={() => setIsOpenModal(true)}
      >
        <Flex>
          <Flex flexDirection="column" flex={2} py={4}>
            <DescricaoContratoCliente item={item} />
            <Divider />
            <ContentTag item={item} />
          </Flex>
          <Flex mx={4}>
            <Divider orientation="vertical" />
          </Flex>
          <Flex flex={1} py={6}>
            <ContentRight item={item} />
          </Flex>
        </Flex>
      </CardDefault>
      <ModalContrato
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        item={item}
      />
    </>
  );
}
